<template>
  <div :class="$style.base">
    {{ heading }}
    <BaseIcon name="arrow-right" />
  </div>
</template>

<script
  setup
  lang="ts"
>
defineProps<{
  heading: string;
}>();
</script>

<style
  lang="scss"
  module
>
.base {
  padding: $spacing;
  border-bottom: 1px solid var(--color-border);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: $spacing * 0.5;

  @include hover {
    background-color: var(--color-highlight);
  }
}
</style>
